import mList from '_v/common/m-list'
import BillAdvSearch from '_v/bill/bill-adv-search'
import SelectTags from '_vc/select-tags'

// 账单列表
export default {
    mixins: [mList],
    components: {
        BillAdvSearch,
        SelectTags,
    },
    data() {
        return {
            userNameMap: {},
            support: {
                multiRooms: true,
            },
        }
    },
    computed: {
        orderBysList() {
            // prettier-ignore
            var list = [
                { id: 'houseName asc', text: '房源排序' },
                { id: 'planAmount desc', text: '账单金额由大到小' },
                { id: 'planAmount asc', text: '账单金额由小到大' },
            ]
            // prettier-ignore
            switch (this.accessName) {
                // 待收
                case 'billDs':
                    list.unshift({id: 'planDate desc', text: '应收款日降序'})
                    list.unshift({id: 'planDate asc', text: '应收款日升序'})
                    list.unshift({id: 'planDate asc,houseName asc', text: '综合排序'})
                    break
                // 待付
                case 'billDf':
                    list.unshift({id: 'planDate desc', text: '待付款日降序'})
                    list.unshift({id: 'planDate asc', text: '待付款日升序'})
                    list.unshift({id: 'planDate asc,houseName asc', text: '综合排序'})
                    break
                // 已收
                case 'billYs':
                    list.unshift({id: 'realDate asc', text: '实收款日升序'})
                    list.unshift({id: 'realDate desc', text: '实收款日降序'})
                    list.unshift({id: 'realDate desc,houseName asc', text: '综合排序'})
                    break
                // 已付
                case 'billYf':
                    list.unshift({id: 'realDate asc', text: '实付款日升序'})
                    list.unshift({id: 'realDate desc', text: '实付款日降序'})
                    list.unshift({id: 'realDate desc,houseName asc', text: '综合排序'})
                    break
                // 作废
                case 'billZf':
                    list.unshift({id: 'invalidTime asc', text: '作废日升序'})
                    list.unshift({id: 'invalidTime desc', text: '作废日降序'})
                    list.unshift({id: 'invalidTime desc,houseName asc', text: '综合排序'})
                    break
            }
            return list
        },
    },
    methods: {
        // 关闭搜索条件
        onAdvItemClose(item, index) {
            var key = item.key

            // daterange
            if (key.indexOf('-') >= 0) {
                var [k1, k2] = key.split('-')

                this.advFilter[k1] = ''
                this.advFilter[k2] = ''
            }
            // select
            else if (typeof this.advFilter[key] === 'object') {
                this.advFilter[key].splice(index, 1)
            }
            // others
            else {
                this.advFilter[key] = ''
            }

            this.$nextTick(() => this.search())
        },
        // 高级搜索
        onAdvConfirm(val, options) {
            this.advOptions = options
            this.$nextTick(() => this.search())
        },
        normalizeAdvFilter(advFilter) {
            var filter = Object.assign({}, advFilter)

            // 是否逾期
            filter.overdue = ''

            Object.keys(filter).forEach((k) => {
                switch (k) {
                    // 待收状态
                    case 'dsStatus':
                        if (this.accessName === 'billDs') {
                            // 待确认
                            if (filter[k].indexOf('10') >= 0) {
                                filter.billStatus = '10'
                            } else {
                                filter.billStatus = '1'
                            }
                        }
                        // 应收
                        if (
                            filter[k].indexOf('1') >= 0 &&
                            filter[k].indexOf('6') < 0
                        ) {
                            filter.overdue = '0'
                        }
                        // 未收
                        if (
                            filter[k].indexOf('6') >= 0 &&
                            filter[k].indexOf('1') < 0
                        ) {
                            filter.overdue = '1'
                        }
                        delete filter[k]
                        break
                    // 待付状态
                    case 'dfStatus':
                        filter[k].overdue = ''
                        // 应付
                        if (
                            filter[k].indexOf('3') >= 0 &&
                            filter[k].indexOf('7') < 0
                        ) {
                            filter.overdue = '0'
                        }
                        // 未付
                        if (
                            filter[k].indexOf('7') >= 0 &&
                            filter[k].indexOf('3') < 0
                        ) {
                            filter.overdue = '1'
                        }
                        delete filter[k]
                        break
                    case 'receiptStatus':
                    case 'payType':
                        if (filter[k].length) {
                            filter[k] = filter[k].join(',')
                        } else {
                            delete filter[k]
                        }

                        break
                    case 'feeType':
                    case 'updateUser':
                        filter[k] = filter[k].join(',')
                        break
                }
            })

            return filter
        },
        normalizeUserName(data) {
            return data.list.reduce((acc, v) => {
                acc[v.id] = v.nickname
                return acc
            }, {})
        },
    },
}
